import React from 'react';

const Footer = () => {
  return (
    <div className=' lg:flex text-center my-10 '>
      <span className=' text-white hover:text-primary transition-all delay-100 ease-in font-semibold'>Frontend Developer</span>
      <span className='ml-[5%] text-white hover:text-primary transition-all delay-100 ease-in font-semibold'>@Copyright 2023 | Favours Excellence</span>
      <span className='ml-[5%] text-white hover:text-primary transition-all delay-100 ease-in font-semibold'>UI/UX Designer</span>
      <span className='ml-[5%] text-white hover:text-primary transition-all delay-100 ease-in font-semibold'>Data Analyst </span>
      <span className='ml-[5%] text-white hover:text-primary transition-all delay-100 ease-in font-semibold'>Designed by @execelegantdesigns</span>
    </div>
  );
}

export default Footer;
